import { useToast } from "@/hooks/utils/useToast";
import { queryKeys } from "@/lib/queryKeys";
import { useSdk } from "@cs_teamwaydev/mailvista-sdk_react";
import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

const useDeleteView = () => {
    const { customViewManager } = useSdk();
    const { toast } = useToast();
    const { t } = useTranslation();
    const queryClient = useQueryClient();

    const deleteView = async (viewId: string): Promise<void> => {
        try {
            await customViewManager.deleteView(viewId);
            queryClient.invalidateQueries({ queryKey: queryKeys.navbarData() });
        } catch (error) {
            console.error(error);
            toast({
                title: t("errors.customViews.deleteView"),
                description: t("errors.global.description"),
                variant: "error",
            });
        }
    };

    return deleteView;
};

export default useDeleteView;
